import { Checkbox, FormControl, FormControlLabel } from '@mui/material';
import { IRON } from 'styles/Colors';
import { isFunction } from 'lodash';
import { styled } from '@mui/material/styles';
import React, { useEffect } from 'react';

const formControlStyle = {
  '& .MuiSvgIcon-root': {
    fontSize: '1.75rem'
  }
};

const UncheckedIcon = styled('span')(() => ({
  borderRadius: 3,
  color: IRON,
  height: 24,
  padding: 2,
  width: 24,
  boxShadow:
    'inset 0 0 0 1px rgba(16,22,26,.2), inset 0 -1px 0 rgba(16,22,26,.1)',

  '.Mui-focusVisible &': {
    outline: '2px auto rgba(19,124,189,.6)',
    outlineOffset: 2
  },

  'input:hover ~ &': {
    backgroundColor: '#ebf1f5'
  },

  'input:disabled ~ &': {
    boxShadow: 'none',
    background: 'rgba(206,217,224,.5)'
  }
}));

const labelStyle = {
  color: IRON
};

export default function BasicCheckbox(props) {
  const {
    id,
    label,
    value,
    error,
    onChange,
    onMount,
    presetDisabled,
    isVisible,
    dynamicLabel,
    additionalProp,
    ...rest
  } = props;

  useEffect(() => {
    if (isFunction(onMount)) {
      onMount(value);
    }
  }, []);

  return (
    <>
      {isVisible && (
        <FormControl css={formControlStyle}>
          <FormControlLabel
            control={
              <Checkbox
                checked={value === true || value === 'true' || false}
                color={!error ? 'primary' : 'error'}
                icon={<UncheckedIcon />}
                id={id}
                inputProps={{
                  'aria-label': 'secondary checkbox'
                }}
                onChange={(e) => {
                  onChange(e.target.checked);
                }}
                {...rest}
              />
            }
            style={labelStyle}
            label={label}
          />
        </FormControl>
      )}
    </>
  );
}
